<template lang="pug">
transition(
  name="slide"
  :enter-class="$style.enter"
  :leave-class="$style.leave"
  :enter-to-class="$style.enterTo"
  :leave-to-class="$style.leaveTo"
  :enter-active-class="$style.enterActive"
  :leave-active-class="$style.leaveActive")
  slot
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "SlideRightTransition"
})
</script>

<style lang="scss" module>
.enterActive,
.leaveActive {
  transition: transform 0.3s;
}
.enter,
.leaveTo {
  transform: translateX(100%);
}
.enterTo,
.leave {
  transform: translateX(0);
}
</style>
